import { useState } from "react";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import "../BucketwiseTable/BucketwiseTable.scss";
import { Flex, Dropdown, Menu, Skeleton } from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";



const BucketStatusTable = ({ data, loading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const allColumns = [
    { title: "Bucket Group", dataIndex: "bucket", key: "bucket",render: (text) => loading ? <Skeleton.Input size="small" active /> : text || 'NA' },
    { title: "Roll Back", dataIndex: "rollback", key: "rollback", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
    { title: "Roll Forward", dataIndex: "rollforward", key: "rollforward", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
    { title: "Stabilized", dataIndex: "stabilized", key: "stabilized", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
    { title: "Normalized", dataIndex: "normalized", key: "normalized", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
    { title: "Total Cases", dataIndex: "total_cases", key: "total_cases", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
  ];
  const [visibleColumns, setVisibleColumns] = useState(
    allColumns.map((col) => col.key)
  );
  const columns = allColumns
    .filter((col) => visibleColumns.includes(col.key))
    .map((col) => ({
      ...col,
      title: (
        <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {col.title}
          {visibleColumns.length > 1 && (
            <CloseOutlined
              style={{
                fontSize: 12,
                marginLeft: 4,
                cursor: "pointer",
                color: "#999",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setVisibleColumns(visibleColumns.filter((k) => k !== col.key));
                setHiddenColumns([...hiddenColumns, col.key]);
              }}
            />
          )}
        </span>
      ),
    }));

  if (hiddenColumns.length > 0) {
    columns.push({
      title: (
        <Dropdown
          overlay={
            <Menu>
              {hiddenColumns.map((key) => {
                const col = allColumns.find((c) => c.key === key);
                return (
                  <Menu.Item
                    key={key}
                    onClick={() => {
                      setVisibleColumns([...visibleColumns, key]);
                      setHiddenColumns(hiddenColumns.filter((k) => k !== key));
                    }}
                  >
                    <PlusOutlined style={{ marginRight: 4 }} />
                    {col.title}
                  </Menu.Item>
                );
              })}
            </Menu>
          }
          trigger={["click"]}
        >
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: "50%",
              background: "#3070F0", // blue
              color: "#fff",
              cursor: "pointer",
              fontSize: 18,
              boxShadow: "0 1px 4px rgba(48,112,240,0.15)",
            }}
          >
            <PlusOutlined />
          </span>
        </Dropdown>
      ),
      dataIndex: "__addColumn__",
      key: "__addColumn__",
      render: () => null,
      sorter: false,
      filterDropdown: null,
    });
  }

  const formattedData = data &&  Object.entries(data)?.map(([key, value]) => ({
    key,
    ...value
  }));


  return (
    <Flex className="bucketwiseContainer">
      <ReusableTable
        columns={columns}
        dataSource={loading ? Array(8).fill({}) : formattedData}
        rowKey="bucketGroup"
        bordered
        pageSize={pageSize}
        CurrentPageNo={currentPage}
        // totalItems={bucketStatusData.length}
        setPageSize={setPageSize}
        triggerChange={(page, size) => {
          setCurrentPage(page);
          setPageSize(size);
        }}
      />
    </Flex>
  );
};

export default BucketStatusTable;
